import { apiClient } from '../../services/apiClient';

export interface CourseExercise {
  id: string;
  title: string;
  description: string;
  type: string;
  points?: number;
  options?: { id: string; text: string }[];
  completed?: boolean;
}

export interface ExerciseCourse {
  courseId: string;
  courseTitle: string;
  exercises: CourseExercise[];
  chapters: CourseChapter[];
}

export interface CourseChapter {
  id: string;
  title: string;
  orderIndex: number;
  firstExerciseId: string;
  exerciseCount: number;
}

export interface CourseSummary {
  id: string;
  title: string;
  description: string;
  instructorId: string;
}

export function fetchCourseExercises(courseId: string): Promise<ExerciseCourse> {
  return apiClient(`/exercises?courseId=${encodeURIComponent(courseId)}`);
}

/** Lists only the courses the current user can access: owned (instructor) or enrolled (student). */
export function fetchMyCourses(): Promise<CourseSummary[]> {
  return apiClient('/courses');
}
